import { type User } from "../types";

export function applyOptimisticRequestFollow(
  user: User,
  targetUserId: string,
): User {
  return {
    ...user,
    requestedFollowing: (user.requestedFollowing ?? []).includes(targetUserId)
      ? user.requestedFollowing
      : [...(user.requestedFollowing ?? []), targetUserId],
  };
}

export function applyOptimisticCancelFollowRequest(
  user: User,
  targetUserId: string,
): User {
  return {
    ...user,
    requestedFollowing: (user.requestedFollowing ?? []).filter(
      (id) => id !== targetUserId,
    ),
  };
}

export function applyOptimisticAcceptFollowRequest(
  user: User,
  requesterId: string,
): User {
  return {
    ...user,
    followers: (user.followers ?? []).includes(requesterId)
      ? user.followers
      : [...(user.followers ?? []), requesterId],
    pendingFollowers: (user.pendingFollowers ?? []).filter(
      (id) => id !== requesterId,
    ),
  };
}

export function applyOptimisticDeclineFollowRequest(
  user: User,
  requesterId: string,
): User {
  return {
    ...user,
    pendingFollowers: (user.pendingFollowers ?? []).filter(
      (id) => id !== requesterId,
    ),
  };
}

export function applyOptimisticUnfollow(
  user: User,
  targetUserId: string,
): User {
  return {
    ...user,
    following: (user.following ?? []).filter((id) => id !== targetUserId),
  };
}

export function applyOptimisticMutualFollow(
  user: User,
  targetUserId: string,
): User {
  return {
    ...user,
    following: (user.following ?? []).includes(targetUserId)
      ? user.following
      : [...(user.following ?? []), targetUserId],
  };
}

export function applyOptimisticRemoveFollower(
  user: User,
  followerId: string,
): User {
  return {
    ...user,
    followers: (user.followers ?? []).filter((id) => id !== followerId),
  };
}